function mainNavigation(){

	$(document).ready(function(){

        "use strict";

        var MOBILE_OPEN = 'mobile-dropdown-open';

	    var screenSize = $( window ).innerWidth();
        $( window ).resize(function() {
            screenSize = $( window ).innerWidth();
            if (screenSize > 992) {
                $('.main-nav__item--with-dropdown').each(function () {
                    $(this).removeClass(MOBILE_OPEN);
                    $(this).find('.sub-nav').css('height', 'auto');
                });
                $('html').removeClass('nav-open');
                $('.main-nav').removeClass('open');
                $('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').removeClass('open');

            }
            else {
                $('.main-nav__item--with-dropdown').each(function () {
                    $(this).find('.sub-nav').css('height',0);
                });
            }
            return screenSize;
        });

        $('.main-nav__item--with-dropdown').click(function (){
            if (screenSize < 993) {
                var self = $(this);
                var sub_nav = $(this).find('.sub-nav');
                self.toggleClass(MOBILE_OPEN);
                if (!self.hasClass(MOBILE_OPEN)) {
                    $(this).find('.sub-nav').animate({
                        height: 0
                    }, 400);
                }
                else {
                    sub_nav.animate({
                        height: sub_nav[0].scrollHeight
                    }, 400, function () {
                        sub_nav.height('auto');
                    });
                }
            }
        });

		$('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').click(function(){
            $(this).toggleClass('open');
            $('html').toggleClass('nav-open');
            $('.main-nav').toggleClass('open');
		});

	});

}

module.exports = mainNavigation;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/01_mainNavigation.js